"use client";

import { useState } from "react";
import Image from "next/image";
import { Play } from "lucide-react";

interface YoutubeVideoCardProps {
  id: string;
  title: string;
}

export function YoutubeVideoCard({ id, title }: YoutubeVideoCardProps) {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="overflow-hidden rounded-2xl bg-white shadow-card dark:bg-surface-dark-raised">
      <div className="group relative aspect-video cursor-pointer" onClick={() => setPlaying(true)}>
        {playing ? (
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1`}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute inset-0 h-full w-full"
          />
        ) : (
          <>
            <Image
              src={`https://img.youtube.com/vi/${id}/hqdefault.jpg`}
              alt={title}
              fill
              className="object-cover transition duration-300 group-hover:scale-105"
              sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
              unoptimized
            />
            <div className="absolute inset-0 bg-black/20 transition group-hover:bg-black/35" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white/90 shadow-lg transition duration-200 group-hover:scale-110">
                <Play className="ml-1 h-6 w-6 fill-brand-navy text-brand-navy" />
              </div>
            </div>
          </>
        )}
      </div>
      <div className="px-4 py-3">
        <p className="line-clamp-2 text-sm font-semibold text-brand-navy dark:text-white">{title}</p>
      </div>
    </div>
  );
}
